/*eslint-disable*/
export default {
  init() {

    const swiperHistory = new Swiper(".our-group__swiper", {
      loop: true,
      slidesPerView: 1,
      direction: "horizontal",
      effect: "fade",
      autoplay: true,
      speed: 900,
      fadeEffect: {
        crossFade: true,
      },
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
      // Navigation arrows
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};
